__turbopack_context__.v({
  "agenda": "Agenda-module-scss-module__hRXbdq__agenda",
  "header": "Agenda-module-scss-module__hRXbdq__header",
  "title": "Agenda-module-scss-module__hRXbdq__title",
});
